// extracted by mini-css-extract-plugin
module.exports = {"card":"ClientAdd_card__1Hzso","main":"ClientAdd_main__3cROr"};